class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      body : document.querySelector('body'),
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: document.querySelectorAll('.menu-secondary-item-region'),
      panel: document.querySelector('.header-localisation'),
      mask : document.querySelector('.header-mask'),
      minicart : document.querySelector('.header-minicart'),
      close : document.querySelector('.button-localisation-close'),
      search : this.querySelector('.localisation-search'),
      predictivesearch : document.querySelector('predictive-search'),
      items : this.querySelectorAll('.localisation-item a')
    };

    this.elements.button.forEach(button => button.addEventListener('click', this.togglePanel.bind(this)));
    this.elements.close.addEventListener('click', this.hidePanel.bind(this));
    this.elements.mask.addEventListener('click', this.hidePanel.bind(this));
    this.elements.search.addEventListener('input', this.instantSearch.bind(this));

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.elements.items.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  
  instantSearch(event) {
    const searchTerm = this.elements.search.value.trim().toLowerCase();
    
    this.elements.items.forEach(item => {
      item.style.display = 'revert';
      if (!item.innerText.toLowerCase().includes(searchTerm)) {
        item.style.display = 'none';
      }
    })
  }

  hidePanel() {
    this.elements.button.forEach(button => button.classList.remove('is-active'));
    this.elements.panel.setAttribute('hidden', true);
    this.elements.mask.classList.remove('is-active');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  togglePanel() {
    if (Array.from(this.elements.button).some(btn => btn.classList.contains('is-active'))) {
      this.hidePanel();
    } else {
      this.openSelector();
    }
  }

  openSelector() {
    this.elements.body.classList.remove('show-menu');
    this.elements.button.forEach(button => button.classList.add('is-active'));
    this.elements.panel.toggleAttribute('hidden');
    if ( this.elements.predictivesearch ) {
      this.elements.predictivesearch.close();
    }
    if ( this.elements.minicart ) {
      this.elements.minicart.classList.remove('is-visible');
    }
    
    this.elements.mask.classList.add('is-active');

  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);